if (!customElements.get('tpt-interactive-banner')) {
  customElements.define(
    'tpt-interactive-banner',
    class TptInteractiveBanner extends HTMLElement {
      constructor() {
        super();

        this.bannerItems = this.querySelectorAll('.tpt-interactive-banner__item');

        this.bannerItems.forEach((banner) => {
          banner.addEventListener('mouseover', this.bannerHover.bind(this));
        });
      }

      bannerHover(event) {
        this.bannerItems.forEach((banner) => {
          banner.classList.remove('active');
        });

        event.currentTarget.classList.add('active');
      }
    }
  );
}
